import {Route, Routes, Outlet} from 'react-router-dom'
import ListWrapper from './list/ListWrapper'

const SalesPage = () => (
  <Routes>
    <Route element={<Outlet />}>
      <Route path='/' element={<ListWrapper />} />
    </Route>
  </Routes>
)

export default SalesPage
